import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Box, Tab, TabList, TabPanel, Tabs, Typography } from "@mui/joy";
import { useAuth } from "../../contexts/AuthContext";
import { EmailQuotaIndicator } from "../../components/marketing/email/EmailQuotaIndicator";
import { TemplatesTab } from "../../components/marketing/email/TemplatesTab";
import { CampaignsTab } from "../../components/marketing/email/CampaignsTab";
import { AudiencesTab } from "../../components/marketing/email/AudiencesTab";
import { DripCampaignsTab } from "../../components/marketing/email/DripCampaignsTab";

export const EmailMarketing: React.FC = () => {
  const { user } = useAuth();
  const [tab, setTab] = useState("campaigns");

  if (user && !user.is_organization_admin) {
    return <Navigate to="/marketing" replace />;
  }

  return (
    <Box>
      <Typography level="body-xs" sx={{ color: "text.tertiary", mb: 1 }}>
        Send branded email campaigns and drip sequences to your CRM contacts.
        Unsubscribed or opted-out contacts are always excluded.
      </Typography>

      <EmailQuotaIndicator />

      <Tabs value={tab} onChange={(_, v) => setTab(v as string)}>
        <TabList sx={{ flexWrap: "wrap" }}>
          <Tab value="campaigns">Campaigns</Tab>
          <Tab value="templates">Templates</Tab>
          <Tab value="drips">Drip Campaigns</Tab>
          <Tab value="audiences">Saved audiences</Tab>
        </TabList>
        <TabPanel value="campaigns" sx={{ px: { xs: 1.5, sm: 2 }, pt: 1.5 }}>
          <CampaignsTab />
        </TabPanel>
        <TabPanel value="templates" sx={{ px: { xs: 1.5, sm: 2 }, pt: 1.5 }}>
          <TemplatesTab />
        </TabPanel>
        <TabPanel value="audiences" sx={{ px: { xs: 1.5, sm: 2 }, pt: 1.5 }}>
          <AudiencesTab />
        </TabPanel>
        <TabPanel value="drips" sx={{ px: { xs: 1.5, sm: 2 }, pt: 1.5 }}>
          <DripCampaignsTab />
        </TabPanel>
      </Tabs>
    </Box>
  );
};
